import React, { useState } from "react";
import Regulations from "../Regulations";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  RegulationsContainer,
  AcceptButton,
} from "./styled";

const TermsOfServiceModal = ({ onAccept, show }) => {
  const [isAccepting, setIsAccepting] = useState(false);

  if (!show) {
    return null;
  }

  const handleAccept = async () => {
    setIsAccepting(true);
    try {
      await onAccept();
    } catch (error) {
      console.error("Failed to accept terms:", error);
      // Optionally, show a toast notification to the user
      setIsAccepting(false);
    }
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Regulamin korzystania z serwisu</ModalHeader>
        <RegulationsContainer>
          <Regulations showBackButton={false} />
        </RegulationsContainer>
        <AcceptButton onClick={handleAccept} disabled={isAccepting}>
          {isAccepting ? "Przetwarzanie..." : "Akceptuję i kontynuuję"}
        </AcceptButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default TermsOfServiceModal;
